<template>
    <h2 class="font-title text-2xl font-medium mt-3 mb-5 text-primary">{{ $t('menu.addresses') }}</h2>
    <div class="p-0 rounded-2xl bg-white">
        <div class="row">

            <div class="col-12 sm:col-6" v-if="addresses.length > 0" v-for="address in addresses" :key="address">
                <div class="p-5 rounded-xl border">
                    <div class="flex items-center justify-between mb-1">
                        <h3 class="text-md font-medium whitespace-nowrap overflow-hidden text-ellipsis">
                            {{ address.full_name }}</h3>
                        <div class="group relative">
                            <button type="button" class="lab-line-circle-more text-text hover:text-heading text-lg"></button>
                            <nav class="w-20 rounded-lg border shadow-md absolute top-0 right-5 z-10 origin-top scale-y-0 transition-all duration-300 group-hover:scale-y-100 bg-white">
                                <button data-modal="#address" type="button" @click="edit(address)"
                                    class="text-xs font-medium py-2 px-3 text-left w-full block border-b last:border-b-0 border-gray-200">
                                    {{ $t("button.edit") }}</button>
                                <button type="button" @click="destroy(address.id)"
                                    class="text-xs font-medium py-2 px-3 text-left w-full block border-b last:border-b-0 border-gray-200">
                                    {{ $t("button.delete") }}</button>
                            </nav>
                        </div>
                    </div>
                    <p class="text-xs leading-5 text-text">
                        <span v-if="address.email">{{ address.email }},&nbsp;</span>
                        <span v-if="address.phone">{{ address.phone }},&nbsp;</span>
                        <span v-if="address.state">{{ address.state }},&nbsp;</span>
                        <span v-if="address.city">{{ address.city }},&nbsp;</span>
                        <span v-if="address.country">{{ address.country }},&nbsp;</span>
                        <span v-if="address.address">{{ address.address }},&nbsp;</span>
                        <span v-if="address.zip_code">{{ address.zip_code }}</span>
                    </p>
                </div>
            </div>
            <div class="col-12 sm:col-6">
                <AddressCreateComponent :props="address" />
            </div>
        </div>
    </div>
</template>

<script>
import alertService from "../../../../services/alertService";
import appService from "../../../../services/appService";
import LoadingComponent from "../../components/LoadingComponent";
import AddressCreateComponent from "./AddressCreateComponent";
import targetService from "../../../../services/targetService";
export default {
    name: "AddressComponent",
    components: {
        LoadingComponent,
        AddressCreateComponent,
    },
    props: ["props"],
    data() {
        return {
            loading: {
                isActive: false,
            },
            localAddress: {},
            targetID: "address",
            addClass: "modal-active",
            address: {
                form: {
                    full_name: "",
                    email: "",
                    country_code: null,
                    phone: "",
                    country: null,
                    state: null,
                    city: null,
                    zip_code: "",
                    address: "",
                },
                search: {
                    paginate: 0,
                    order_column: "id",
                    order_type: "asc",

                },
                flag: "",
                states: [],
                cities: []
            },
        }
    },
    mounted() {
        this.list();
    },
    computed: {
        addresses: function () {

            return this.$store.getters["frontendAddress/lists"];
        },
    },
    methods: {
        list: function () {
            this.loading.isActive = true;
            this.$store.dispatch("frontendAddress/lists", {
                search: this.address.search
            }).then((res) => {
                this.loading.isActive = false;
            }).catch((err) => {
                this.loading.isActive = false;
            });
        },
        edit: function (address) {
            targetService.showTarget(this.targetID, this.addClass);
            this.loading.isActive = true;
            this.$store.dispatch("frontendAddress/edit", address.id).then(async (res) => {

                if (address.state !== "") {
                    await this.$store.dispatch('frontendCountryStateCity/statesByCountry', address.country)
                        .then((res) => {
                            this.address.states = res.data.data;
                        })
                    await this.$store.dispatch('frontendCountryStateCity/citiesByState', address.state)
                        .then((res) => {
                            this.address.cities = res.data.data;
                        })

                    if (address.city === "") {
                        this.address.form.city = null;
                    }



                } else {

                    await this.$store.dispatch('frontendCountryStateCity/statesByCountry', address.country)
                            .then((res) => {
                                this.address.states = res.data.data;
                            })
                        this.address.form.state = null;
                        this.address.form.city = null;
                }

                setTimeout(() => {
                    this.address.form = {
                        full_name: address.full_name,
                        email: address.email,
                        country_code: address.country_code,
                        phone: address.phone,
                        country: address.country,
                        state: address.state,
                        city: address.city,
                        zip_code: address.zip_code,
                        address: address.address,
                    };

                    if (address.state === "") {
                        this.address.form.state = null;
                    }

                    if (address.city === "") {
                        this.address.form.city = null;
                    }

                }, 200);

                this.loading.isActive = false;

                this.$store.dispatch('frontendCountryCode/callingCode', address.country_code).then(res => {
                    this.address.flag = res.data.data.flag_emoji;
                    this.loading.isActive = false;
                }).catch((err) => {
                    this.loading.isActive = false;
                });
            }).catch((err) => {
                alertService.error(err.response.data.message);
            });
        },
        destroy: function (addressId) {
            appService.destroyConfirmation().then((res) => {
                try {
                    this.loading.isActive = true;
                    this.$store.dispatch("frontendAddress/destroy", {
                        id: addressId,
                        search: this.address.search,
                    }).then((res) => {
                        this.loading.isActive = false;
                        alertService.successFlip(null, this.$t("label.address"));
                    }).catch((err) => {
                        this.loading.isActive = false;
                        alertService.error(err.response.data.message);
                    });
                } catch (err) {
                    this.loading.isActive = false;
                    alertService.error(err.response.data.message);
                }
            }).catch((err) => {
                this.loading.isActive = false;
            });
        },
    }
}
</script>
